import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * NOTE (08/09/2026): The previous version of this class overrode `updateButtonStates()`
 * to always recalculate button disabled-state from min/max, ignoring `serverDisabledMinus`
 * / `serverDisabledPlus`. That defeated the `can_update_quantity: false` flag rendered
 * server-side in `snippets/cart-products.liquid` for subscription lines (selling_plan_allocation),
 * letting customers change quantity on a line whose selling plan no longer matched the
 * quantity (e.g. "2 cajas" plan at 30.31% left at quantity 1 after a manual decrease).
 * Removing the override restores the parent class's server-respecting behavior for the
 * minus/plus buttons, while keeping the cart-specific `getEffectiveMax()` override intact.
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}